export const COUNTRIES = {
  usa: {
    label: 'USA',
    value: 'usa',
  },
  canada: {
    label: 'Canada',
    value: 'canada',
  },
};

export const CANADA_STATES = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
];

export const USA_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const FORM_CONFIG = {
  member_agent: { key: 'member_agent' },
  member_firstname: { key: 'member_firstname', required: true },
  member_lastname: { key: 'member_lastname', required: true },

  member_current_legal_address: { key: 'member_current_legal_address', required: true },
  member_city: { key: 'member_city', required: true },
  member_country: { key: 'member_country', required: true },
  member_state_or_province: { key: 'member_state_or_province', required: true },
  member_zipcode: { key: 'member_zipcode', required: true },

  member_is_different_billing_address: { key: 'member_is_different_billing_address' },

  member_billing_address: { key: 'member_billing_address' },
  member_billing_city: { key: 'member_billing_city' },
  member_billing_country: { key: 'member_billing_country' },
  member_billing_state_or_province: { key: 'member_billing_state_or_province' },
  member_billing_zipcode: { key: 'member_billing_zipcode' },

  member_dob: { key: 'member_dob', required: true },
  member_sex: {
    key: 'member_sex',
    options: [{ value: 'male', label: 'M' }, { value: 'female', label: 'F' }],
    required: true,
  },
  member_social_security_number: { key: 'member_social_security_number', required: true },
  member_home_phone_number: { key: 'member_home_phone_number', required: true },
  member_email: { key: 'member_email', required: true },
  member_travel_assurence_plan: {
    key: 'member_travel_assurence_plan',
    options: [{ value: 'funeral', label: 'Burial' }, { value: 'cremation', label: 'Cremation' }],
    required: true,
  },
  member_travel_assurence_plan_price: { key: 'member_travel_assurence_plan_price', required: true },
  member_travel_assurence_plan_months: { key: 'member_travel_assurence_plan_months', required: true },
  member_emergency_firstname: { key: 'member_emergency_firstname' },
  member_emergency_lastname: { key: 'member_emergency_lastname' },
  member_emergency_email: { key: 'member_emergency_email' },
  member_emergency_phone_number: { key: 'member_emergency_phone_number' },
  member_funeral_home_id: { key: 'member_funeral_home_id' },
  member_funeral_home_name: { key: 'member_funeral_home_name' },
  member_funeral_home_city: { key: 'member_funeral_home_city' },
  member_funeral_home_state: { key: 'member_funeral_home_state' },
  agency_nonce: { key: 'agency_nonce' },
  member_already_paid: { key: 'member_already_paid' },
};
